/**
 * THIS IS AN AUTOGENERATED FILE. DO NOT EDIT THIS FILE DIRECTLY
 * To add new icons to the system, or to update existing icons, run `clyde mana assets sync -t icons`.
 */

import * as React from 'react';
import tokens from '@discordapp/tokens/web';

import addDefaultIconProps from '../addDefaultIconProps';
import {getIconSize} from '../getIconSize';

import type {SingleColorIconProps} from '../IconTypes';

/**
 * ![AppsIcon](data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAYCAYAAADgdz34AAAACXBIWXMAAAsTAAALEwEAmpwYAAABxklEQVR4nN1Uvy8EQRTeU1EpJBq9RqFRCgokcjvvvcXse5vgosJ/oLviGhLxF2iEXkcUOqVfwV9wnCuORC9CZu/82LuZWUpeMpnszjfzzfve9yYI/lWExNOAUlckVUDeUySlYlEPuPBa615AOVQoT0C8FQRBwUsAKDdA8tY+FPG1imSqHa9IdjNYiJedh5ub2g6HL5JaBh/Fwwr5NYNBvtNa91gJjBw+AiC5z2bLR3Ycr9sJUPa9BMh7H1hEnnBmivJMtNjXqT/JvV8iKbWgBUA5z5Fz2yIR13ybii03KSVDOVK+GSd2ZgDxpHGLy0VBK6JooR9IXnIyuLDWIXVHUQ+kBW/2QVUhPxjy7GUEAPlEEZ+1DyA+IOLB4H8HQLyUugripXyszBsZQ0zmvMDxUqlbIVcA5fijQ9O5+V0x67Z9iviyVdhLL0FIyajXehCPWQ5fa8Ot+lId8RPIyHdZAOXK0QNXVrmAeDOngTY+b26s+4uHsUmAUv9pd4aYzPkyUMSznTXAhIC44XghG2a9M2tZ/Y5DTFacNUhJiGdsBCHxjGvPj11kolwudwHKKRDfAslOOqOcmv+uPRCxVsiPpvC5BH8y3gEIDdGO42YptAAAAABJRU5ErkJggg==)
 */
export const AppsIcon = ({
  size = 'md',
  width,
  height,
  color = tokens.colors.INTERACTIVE_NORMAL,
  colorClass = '',
  ...props
}: SingleColorIconProps) => {
  const iconSize = getIconSize(size);
  const iconWidth = iconSize?.width ?? width;
  const iconHeight = iconSize?.height ?? height;
  return (
    <svg
      {...addDefaultIconProps(props)}
      xmlns="http://www.w3.org/2000/svg"
      width={iconWidth}
      height={iconHeight}
      fill="none"
      viewBox="0 0 24 24">
      <path
        fill={typeof color === 'string' ? color : color.css}
        d="M2.06 7.61c-.25.95.31 1.92 1.26 2.18l4.3 1.15c.94.25 1.91-.31 2.17-1.26l1.15-4.3c.25-.94-.31-1.91-1.26-2.17l-4.3-1.15c-.94-.25-1.91.31-2.17 1.26l-1.15 4.3ZM12.98 7.87a2 2 0 0 0 1.75 2.95H20a2 2 0 0 0 1.76-2.95l-2.63-4.83a2 2 0 0 0-3.51 0l-2.63 4.83ZM5.86 13.27a.89.89 0 0 1 1.28 0l.75.77a.9.9 0 0 0 .54.26l1.06.12c.5.06.85.52.8 1.02l-.13 1.08c-.02.2.03.42.14.6l.56.92c.27.43.14 1-.28 1.26l-.9.58a.92.92 0 0 0-.37.48l-.36 1.02a.9.9 0 0 1-1.15.57l-1-.36a.89.89 0 0 0-.6 0l-1 .36a.9.9 0 0 1-1.15-.57l-.36-1.02a.92.92 0 0 0-.37-.48l-.9-.58a.93.93 0 0 1-.28-1.26l.56-.93c.11-.17.16-.38.14-.59l-.12-1.08c-.06-.5.3-.96.8-1.02l1.05-.12a.9.9 0 0 0 .54-.26l.75-.77ZM18.52 13.71a1.1 1.1 0 0 0-2.04 0l-.46 1.24c-.19.5-.57.88-1.07 1.07l-1.24.46a1.1 1.1 0 0 0 0 2.04l1.24.46c.5.19.88.57 1.07 1.07l.46 1.24c.35.95 1.7.95 2.04 0l.46-1.24c.19-.5.57-.88 1.07-1.07l1.24-.46a1.1 1.1 0 0 0 0-2.04l-1.24-.46a1.8 1.8 0 0 1-1.07-1.07l-.46-1.24Z"
        className={colorClass}
      />
    </svg>
  );
};
